import React, { useEffect } from "react";

import {
  TextField,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { format } from 'date-fns';
import { DateTime } from "luxon";
import { InputAdornment } from '@mui/material';

//https://stackoverflow.com/questions/73745743/cant-get-formik-form-to-work-with-material-ui
//This is stupid and I hate it.
//Please find a work around for this. Doing it inline either wont connect the name to the field,
//Or unselects after typing

const MuiTextField = ({ field, form, ...props }) => {

  useEffect(() => {

  },[])
  return <TextField {...field} {...props}
  onWheel={event => {
    event.target.blur();
    event.preventDefault();
    return false;
  }}/>;
};

const MuiMoneyTextField = ({ field, form, ...props }) => {
  return <TextField {...field} {...props} 
    onBlur={(e) => {
      //Set to 2 decimal places
      form.setFieldValue(field.name, parseFloat(e.target.value).toFixed(2))
    }}
    InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, inputProps: { min: 0, step: 0.01 } }}
  />;
};


const MuiTextFieldSlug = ({ field, form, ...props }) => {
  return <TextField {...field} {...props} />;
};


const MuiTextArea = ({ field, form, ...props }) => {
  return <TextField multiline={true} minRows={3} {...field} {...props} />;
}


const MuiCheckbox = ({ field, form, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox color="green" {...field} {...props} checked={field.value} />
      }
      label={props.label}
    />
  )
}

const MuiSwitch = ({ field, form, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Switch {...field} {...props} checked={field.value} />
      }
      label={props.label}
    />
  )
}

const MuiCheckboxForcedValue = ({ field, form, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          {...field}
          {...props}
          checked={field.value == props.checkValue}
          onChange={() => {
            form.setFieldValue(field.name, props.checkValue)
          }}
        />
      }
      label={props.label}
    />
  )
}



const MuiCheckboxForcedValueArray = ({ field, form, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          {...field}
          {...props}
          checked={(field.value||[]).includes(props.checkValue)}
          onChange={() => {
            //check if field value is array
            if(!Array.isArray(field.value)){
              field.value = []
            }
            if(field.value.includes(props.checkValue)){
              field.value = field.value.filter(value => value != props.checkValue)
            } else {
              field.value.push(props.checkValue)
            }
            form.setFieldValue(field.name, field.value)
          }}
        />
      }
      label={props.label}
    />
  )
}


const getDateWithoutTimezone = (value) => {
  let temp_value = ""
  if(value){
    if(typeof value == "object") {
      temp_value = value.toISOString()
    } else {
      temp_value = value
    }
    return new Date(temp_value.split("T")[0]+" 00:00:00");
  }
  return null
}

//DEAR GOD HELP ME
//https://github.com/mui/mui-x/pull/8261/files
//https://mui.com/x/react-date-pickers/timezone/
//Adjust at own peril.
const MuiDatePicker = ({ field, form, ...props }) => {
  return (
    <DatePicker
      {...field}
      {...props}
      format="MM-dd-yyyy"
      timezone="system"
      value={
        field.value
          ? DateTime.fromISO(field.value)
          : null
      }
      onChange={(newValue) => {
        const formatted = newValue
          ? newValue.toFormat("yyyy-MM-dd")
          : null;

        form.setFieldValue(field.name, formatted);
        if(props.afterChange){
          props.afterChange(newValue, formatted)
        }
        field.onChange(formatted);
      }}
      slotProps={{
        textField: {
          size: "small",
          fullWidth: true,
        },
        actionBar: {
          actions: ["clear"],
        },
      }}
    />
  );
};

const MuiDateTimePicker = ({ field, form, ...props }) => {
  if(typeof field.value == "string"){
    field.value = Date.parse(field.value)
  }
  return <DateTimePicker
    {...field} {...props} slotProps={{
      textField: {...props},
      actionBar: {
        actions: ['clear']
      }
    }}
    onChange={date => {
      form.setFieldValue(field.name, date)
    }}

  />;
}

export {
  MuiTextField,
  MuiTextArea,
  MuiDatePicker,
  MuiDateTimePicker,
  MuiCheckbox,
  MuiCheckboxForcedValue,
  MuiSwitch,
  MuiCheckboxForcedValueArray,
  MuiMoneyTextField
};
